import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Blob from 'components/shared/Blob';
import Heading from 'components/shared/Heading';
import Text from 'components/shared/Text';
import styles from './empty.module.scss';

function TableEmpty(props) {
  return (
    <div
      className={classnames(styles.emptyContainer, {
        [styles.emptyContainerWithMaxHeight]: props.hasMaxHeight
      })}>
      <Blob />
      <Heading tag="h3" styles={[styles.emptyHeading]}>
        {props.title}
      </Heading>
      {props.message && <Text>{props.message}</Text>}
    </div>
  );
}

TableEmpty.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  hasMaxHeight: PropTypes.bool.isRequired
};

TableEmpty.defaultProps = {
  message: null
};

export default TableEmpty;
